/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <img
      src="../reactjs/static/images/profile/hydration/right-arrow-white.svg"
      alt="next arrow"
      style={{
        position: "absolute",
        right: "0",
        width: "48px",
        bottom: "0",
        cursor: "pointer",
        zIndex: "1",
        transform: "translateY(100%)",
      }}
      onClick={onClick}
      tabIndex={0}
      onKeyUp={onClick}
      role="button"
    />
  );
};

const CustomPreviousArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <img
      src="../reactjs/static/images/profile/hydration/left-arrow-white.svg"
      alt="previous arrow"
      style={{
        position: "absolute",
        right: "53px",
        width: "48px",
        bottom: "0",
        cursor: "pointer",
        zIndex: "1",
        transform: "translateY(100%)",
      }}
      onClick={onClick}
      tabIndex={0}
      onKeyUp={onClick}
      role="button"
    />
  );
};

function GainfulCarousel(props) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    adaptiveHeight: true,
    swipeToSlide: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPreviousArrow />,
  };

  return (
    <>
      <div className="carousel-container">
        <h2>{props.title}</h2>
        <Slider {...settings}>
          {props.items.map((item) => (
            <div className="slick-slide-container" key={Math.random()}>
              <div className="slide-contents">{item.content}</div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}

export default GainfulCarousel;